import { takeLatest } from 'redux-saga/effects';
import { names } from './actions';
import * as sagas from './sagas';

export default function* watchers() {
  yield takeLatest(names.navigate, sagas.navigateSaga);
  yield takeLatest(names.reconcileNav, sagas.reconcileNavSaga);
}
